<template>
  <div v-if="!isPortalPage">
    <router-view />
  </div>
  <!-- TODO: Uncomment this -->
  <div v-else class="appContainer">
    <div class="main">
      <Header />

      <router-view />
    </div>
    <Footer />
  </div>
</template>
<script>
'use strict';

// Imports.
import { mapState, useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { computed } from 'vue';
// Component imports.
import Header from '/src/pages/layout/Header.vue';
import Footer from '/src/pages/layout/Footer.vue';

// Set up the default application component.

export default {
  components: {
    Header,
    Footer
  },

  setup(props, context) {
    const router = useRouter();
    const store = useStore();
    const isPortalPage = computed(() => {
      return router.currentRoute.value.path === '/portal';
    });
    return {
      isPortalPage,
      router
    };
  },

  computed: {
    ...mapState({
      alert: state => Object.assign({}, state.alert)
    })
  },

  mounted() {
    this.$store.$toasts = this.$toasts;
  },

  watch: {
    alert: {
      deep: true,
      handler: function(newAlert) {
        let message = newAlert.message;
        if (this.lastMessage === message) {
          // TODO remove this once alert hijacking is removed
          return;
        }
        let type = newAlert.type;
        let duration = newAlert.duration;
        let metadata = newAlert.metadata ? newAlert.metadata : {};

        if (message && type) {
          this.$toasts.base('', {
            message: message,
            type: type,
            duration: duration,
            metadata: metadata
          });
          this.lastMessage = message;
        } else {
          // TODO: dispatch a clear event.
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
body {
}
.appContainer {
  display: flex;
  flex-direction: column;

  .main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Hide scrollbars */
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
